import { render, staticRenderFns } from "./BetOfferBox.vue?vue&type=template&id=cec7ce10&scoped=true&"
import script from "./BetOfferBox.vue?vue&type=script&lang=js&"
export * from "./BetOfferBox.vue?vue&type=script&lang=js&"
import style0 from "./BetOfferBox.vue?vue&type=style&index=0&id=cec7ce10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cec7ce10",
  null
  
)

export default component.exports